import { Api } from "../config/request";

const getCurrentSeasons = async () => {
    let response = await Api.PostRequest("/getCurrentSeasons");
    return response.data;
};

const getSeasonDetails = async (data) => {
    let response = await Api.PostRequest("/getSeasonDetails", data);
    return response.data;
};

const seasonApi = {
    getCurrentSeasons,
    getSeasonDetails
};

export default seasonApi;
